import { render, staticRenderFns } from "./Referidos.vue?vue&type=template&id=22464c2c&scoped=true"
import script from "./Referidos.vue?vue&type=script&lang=js"
export * from "./Referidos.vue?vue&type=script&lang=js"
import style0 from "./Referidos.vue?vue&type=style&index=0&id=22464c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22464c2c",
  null
  
)

export default component.exports